// services/aiAgentsService.js
import { API_ENDPOINTS, PATIENT_API_ENDPOINTS } from "../config";
import { store } from "../State/store/configureStore";
import { http } from "../utils/http";

class AiAgentsService {
  getAllCrews(patientTypeId) {
    const api = API_ENDPOINTS.getAllCrews(patientTypeId);
    return http.request(api, "get");
  }

  updateCrewConfiguration(patientTypeId, payload) {
    const api = API_ENDPOINTS.updateCrew(patientTypeId, payload.id);
    return http.request(api, "patch", payload);
  }

  createCrewConfiguration(patientTypeId, payload) {
    const api = API_ENDPOINTS.createCrew(patientTypeId);
    return http.request(api, "post", payload);
  }

  deleteCrewConfiguration(patientTypeId, crewId) {
    const api = API_ENDPOINTS.deleteCrew(patientTypeId, crewId);
    return http.request(api, "delete");
  }

  createPatientSummary(patientTypeId) {
    const api = API_ENDPOINTS.createPatientSummary(patientTypeId);
    return http.request(api, "get");
  }

  savePatientSummary(patientId, summary) {
    const api = API_ENDPOINTS.savePatientSummary(patientId);
    return http.request(api, "post", { markdown: summary });
  }

  getAssistants(patientTypeId) {
    let role = store.getState().user.role;
    let api = null;
    if (role === "ROLE_PATIENT") {
      api = PATIENT_API_ENDPOINTS.getAssistants;
    } else {
      api = API_ENDPOINTS.getAssistants(patientTypeId);
    }

    return http.request(api, "get");
  }

  deleteAssistant(patientTypeId, assistantId) {
    const api = API_ENDPOINTS.deleteAssistant(patientTypeId, assistantId);
    return http.request(api, "delete");
  }

  updateAssistant(patientTypeId, assistantId, payload) {
    const api = API_ENDPOINTS.updateAssistant(patientTypeId, assistantId);
    return http.request(api, "patch", payload);
  }

  createAssistant(patientTypeId, payload) {
    const api = API_ENDPOINTS.createAssistants(patientTypeId);
    return http.request(api, "post", payload);
  }

  getReactAgents(patientTypeId) {
    const api = API_ENDPOINTS.getReactAgents(patientTypeId);
    return http.request(api, "get");
  }

  deleteReactAgent(patientTypeId, reactAgentId) {
    const api = API_ENDPOINTS.deleteReactAgent(patientTypeId, reactAgentId);
    return http.request(api, "delete");
  }

  updateReactAgent(patientTypeId, reactAgentId, payload) {
    const api = API_ENDPOINTS.updateReactAgent(patientTypeId, reactAgentId);
    return http.request(api, "put", payload);
  }

  createReactAgent(patientTypeId, payload) {
    const api = API_ENDPOINTS.createReactAgent(patientTypeId);
    return http.request(api, "post", payload);
  }

  getSpeechToken() {
    return http.request(API_ENDPOINTS.getSpeechToken());
  }

  enhanceTranscript(transcript) {
    return http.request(API_ENDPOINTS.enhanceTranscript(), "post", {
      transcript,
    });
  }

  generateSmartNote(patientId, templateId) {
    return http.request(API_ENDPOINTS.generateSmartNote(patientId, templateId));
  }

  generateSmartDocument(patientId, templateId) {
    return http.request(
      API_ENDPOINTS.generateSmartDocument(patientId, templateId)
    );
  }

  saveSmartDocument(patientId, data) {
    return http.request(
      API_ENDPOINTS.saveSmartDocument(patientId),
      "post",
      data
    );
  }

  // Save Edits feature methods
  saveGeneratedDocument(patientId, data) {
    return http.request(
      API_ENDPOINTS.saveGeneratedDocument(patientId),
      "post",
      data
    );
  }

  loadDraftDocuments(patientId, page = 0, size = 20) {
    return http.request(
      API_ENDPOINTS.loadDraftDocuments(patientId, page, size)
    );
  }

  deleteGeneratedDocument(patientId, docId) {
    return http.request(
      API_ENDPOINTS.deleteGeneratedDocument(patientId, docId),
      "delete"
    );
  }

  finalizeGeneratedDocument(patientId, docId, data) {
    return http.request(
      API_ENDPOINTS.finalizeGeneratedDocument(patientId, docId),
      "post",
      data
    );
  }

  restoreDocumentVersion(patientId, docId, versionNumber) {
    return http.request(
      API_ENDPOINTS.restoreDocumentVersion(patientId, docId, versionNumber),
      "post"
    );
  }
}

const aiAgentsService = new AiAgentsService();
export default aiAgentsService;
